import React, { useState } from "react";
import Footer from "../components/Footer";
import { Banner, NewBanner } from "../components/Home/Banner";
import { toast } from "react-toastify";
import contact from "../assets/contact.png";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar";

const Find = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const validate = () => {
    const { first_name, last_name, email, phone, message } = formData;

    if (!first_name || first_name.length < 2) {
      toast.error("First name must be at least 2 characters.");
      return false;
    }
    if (!last_name || last_name.length < 2) {
      toast.error("Last name must be at least 2 characters.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be 10–15 digits.");
      return false;
    }
    if (!message || message.length < 10) {
      toast.error("Message must be at least 10 characters.");
      return false;
    }
    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}api/inquiry`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data.data?.message || "Message sent successfully!");
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>Perfune Enquiry</title>
        <meta name="description" content={`Welcome to Perfune Enquiry page`} />
      </Helmet>
      {/* <Topbar /> */}
      {/* <Banner
        Title="Let's"
        secttile="Connect"
        dec1="Awaken your senses with every interaction — we’re here to help, inspire, and guide you."
        dec2="Whether you have questions, ideas, or collaboration opportunities, reach out to us. Let’s build connections and craft experiences that leave a lasting impression."
        img={contact}
      /> */}
      <Navbar />
      <Banner
        Title="Let's"
        secttile="Connect"
        dec1="Awaken your senses with every interaction — we’re here to help, inspire, and guide you."
        dec2="Whether you have questions, ideas, or collaboration opportunities, reach out to us. Let’s build connections and craft experiences that leave a lasting impression."
        img={contact}
      />
      <div className="w-full px-[1rem] sm:px-[4rem] md:px-[10rem] bg-white flex flex-col md:flex-row items-start gap-8 py-16">
        {/* Left: Heading */}
        <div className="w-full md:w-1/3 flex justify-center md:justify-start">
          <h1 className="text-[4rem] sm:text-[6rem] md:text-[9rem] font-bold font-syne text-gradient leading-none text-center md:text-left">
            Let's Talk
          </h1>
        </div>

        {/* Right: Content Box */}
        <div className="w-full md:w-2/3  p-8 rounded-2xl shadow-lg">
          <form className="space-y-6 font-outfit" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* First Name */}
              <div>
                <label className="block mb-1 text-sm font-semibold text-gray-500">
                  First Name
                </label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="Enter Your First Name ..."
                  className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Last Name */}
              <div>
                <label className="block mb-1 text-sm font-semibold text-gray-500">
                  Last Name
                </label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Enter Your Last Name ..."
                  className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className="block mb-1 text-sm font-semibold text-gray-500">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Your Email Address ..."
                  className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block mb-1 text-sm font-semibold text-gray-500">
                  Phone Number
                </label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter Your Phone Number ..."
                  className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>

            {/* Message */}
            <div>
              <label className="block mb-1 text-sm font-semibold text-gray-500">
                Message
              </label>
              <textarea
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter Your Message ..."
                className="w-full p-3 rounded-lg border border-gray-600 bg-transparent text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              ></textarea>
            </div>

            {/* Optional description */}
            <p className="text-sm text-gray-500">
              We’d love to hear from you---Whether you have a question about a
              product, need help with an order, or simply want to share your
              experience, our team is here to help
            </p>

            {/* Submit button */}
            <button
              type="submit"
              className="bg-gray-500 text-white px-6 py-3 rounded-full hover:opacity-90 transition-all"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      {/* bottom */}
      {/* <div>
        <div className="CallAction bg-black py-10">
          <div className="container mx-auto px-4">
            <div className="main-call-action gradient rounded-lg">
              <ul className="grid grid-cols-1 md:grid-cols-3 gap-5 text-center py-10 justify-center items-center ">
                <li className="text-center flex flex-col justify-center items-center">
                  <Link
                    className=" font-syne flex flex-col justify-center items-center"
                    to={`mailto:info@info@aruhifragrances.com`}
                  >
                    <span className="text-4xl mb-5">
                      <FaEnvelope />
                    </span>
                    info@aruhifragrances.com , wholesale@aruhifragrances.com
                  </Link>
                </li>
                <li className=" flex flex-col justify-center items-center">
                  <Link
                    className="font-syne flex flex-col justify-center items-center"
                    to={`tel:(774) 268-2232`}
                  >
                    <span className=" text-4xl mb-5">
                      <FaPhoneAlt />
                    </span>
                    (848) 667-0850
                  </Link>
                </li>
                <li className="text-center flex flex-col justify-center items-center ">
                  <Link
                    className=" font-syne flex flex-col justify-center items-center"
                    target="__blank"
                    to="https://maps.app.goo.gl/fQgXEskatzqqkd3G8"
                  >
                    <span className=" text-4xl mb-5">
                      <FaLocationDot />
                    </span>
                    1514 Azalea Dr North Brunswick Township, NJ 08902 USA
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
};

export default Find;
